import styled from 'styled-components';

export const NinedownText = styled.span`
    p:last-child {
        margin-bottom: 0;
    }
`;
